import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { HttpService } from '../../../shared/services/http/http-client.service';

const API = environment.url_server;

@Injectable({
  providedIn: 'root'
})
export class SimulacaoVendaWebtefService {

  constructor(private http: HttpClient, private httpService: HttpService) { }

  simularVenda(data: any, successHandle: Function, errorHandle: Function) {
    return this.httpService.doPost('/enterprise/simulaVendaPinPos', data, successHandle, errorHandle);
  }

  simularVendaPromise(data: any) {
    return this.http.post(environment.url_server + '/enterprise/simulaVendaPinPos', data);
  }

  vendaPromise(data: any) {
    return this.http.post(environment.url_server + '/pinpad/venda', data, {  responseType: 'text'});
  }

  confirmaVendaPromise(data: any) {
    return this.http.post(environment.url_server + '/pinpad/confirmaVenda', data, {  responseType: 'text'});
  }

  registrarLogTransacao(data: any) {
    return this.http.post(environment.url_server + '/pinpad/registrarLogTransacao', data);
  }

  buscaTerminais(data: any, successHandle: Function, errorHandle: Function) {
    return this.httpService.doGet('/enterprise/buscaTerminais', data, successHandle, errorHandle);
  }

  buscaTerminaisPromise(params: any) {
    return this.http.get(environment.url_server + '/enterprise/buscaTerminais', {params, observe: "response"  })
  }

}
